import React, { useRef, useState, useEffect } from 'react'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
import { XDivider, YDivider } from '../../../irmlib/src/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { Label } from 'irmlib/components/Controls'
import styled from 'styled-components'
import PropTypes from 'prop-types'
// import GoBackSubtitle from '../../Controls/GoBackSubtitle'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { Container, TextField, Typography, makeStyles } from '@material-ui/core'
// import { useLocation } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as gdeTransactionsLite from '../../../services/firestore/gdeTransactionsLite'
import TemplateFormat from '../Template/ActivityTemplateFormation.jsx'
import { defaultDateFormat2, countryConfig } from '../../../common/constants'
import {
  CancelButton,
  SaveButton,
} from '../../../irmlib/src/components/FormControls'
import {
  openGeneralDialog,
  closeGeneralDialog,
  useSnackbar,
} from 'irmlib/containers'
// import { OutlinedButton } from 'irmlib/components/Controls'
import { ContainedButton } from 'irmlib/components/Controls/Button'
import * as routePaths from '../../../navigation/routePaths'
import { errorToast } from '../../../common/functions'
import { useHistory, useLocation } from 'react-router-dom'

import IconButton from '@mui/material/IconButton'
import EditIcon from '@material-ui/icons/Edit'




const PrimaryLabel = styled('div')`
  cursor: pointer;
`

const VerticalDivider = () => <YDivider height="20px" />

const useStyles = makeStyles((theme) => ({
  containerGroup: {
    display: 'flex',
    alignItems: 'flex-end',
  
  },
  ProgressBox: {
    padding: theme.spacing(1),
    borderRadius: 8,
    width: '200px',
    margin: 0,
    border: '1px solid #c9c9c9',
    fontSize: '0.875rem',
    marginRight: '10px',
    textAlign: 'center',
  },
  container: {
    padding: theme.spacing(1),
    borderRadius: 8,
    width: 'fit-content',
    margin: 0,
    border: '1px solid #c9c9c9',
    fontSize: '0.875rem',
    marginRight: '10px',
  
  },
  progressContainer: {
    marginLeft: '50px',
    display: 'flex',
    height: 'fit-content',
  },
  content: {
    fontSize: '0.875rem',
    lineHeight: 2.5,
    display: 'flex'
  },
  contentBox: {
    fontSize: '0.875rem',
    lineHeight: 2,
  },
  value: {
    color: '#58595b',
  },
  chipGroup: {
    '& .MuiChip-root': {
      margin: '0 5px',
      borderRadius: '20px',
      fontSize: '14px',
      height: '32px',
    },
  },
  progressBarContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  percentage: {
    marginLeft: theme.spacing(1),
  },
}))

const DetailsSubtitle = (props) => {
  return (
    <>
      <PrimaryLabel
        id={'boxList_button_activityDetails'}
        onClick={props.onShowBoxList}
        style={props.boxColor ? { color: '#1975bc' } : { color: '#58595b' }}
      >
        <Label>forms.back</Label>
      </PrimaryLabel>
    </>
  )
}

DetailsSubtitle.propTypes = {
  onShowBoxList: PropTypes.func,
  boxColor: PropTypes.bool,
}

const getService = async (setState) => {
  const getObject = {}
  return Promise.resolve(getObject)
}

const initialSate = {
  templateData: false,
  validationErrors: {},
  skpEncoding: {},
}

const ModifyTemplate = () => {
  const location = useLocation()
  const templateId = location.pathname.split('/')[2]
  const { t } = useTranslation()
  const classes = useStyles()
  const refLocalBusyCursor = useRef(null)
  const tableRef = useRef()
  const [, setState, getState] = useMergeState(initialSate)
  const snackBar = useSnackbar()
  const history = useHistory()

  const formTemplate = []
  // eslint-disable-next-line
  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  useEffect(async () => {
    getTemplateData(templateId)
  }, [templateId])

  useEffect(() => {
    const currentName = getState()?.templateData?.customTemplateName
    if (currentName) {
      setEditedCustomTemplateName(currentName)
    }
  }, [getState()?.templateData?.customTemplateName])

  const getTemplateData = async () => {
    const templateData = await gdeTransactionsLite.getTemplateById(templateId)
    const [, , , , skpEncoding] = await gdeTransactions.getGdeConfig()
    setState({
      templateData: templateData,
      skpEncoding: skpEncoding,
    })
  }

  const Buttons = (props) => (
    <>
      <CancelButton
        id={'createTemplate_button_cancel'}
        arrRefs={props.arrRefs}
        onClick={props.handleCancel}
      />
      <XDivider width="10px" />
      <SaveButton
        id={'createTemplate_button_save'}
        disabled={Object.keys(props.validationErrors).length > 0}
        arrRefs={props.arrRefs}
        postService={props.handlePageSave}
      />
    </>
  )

  Buttons.propTypes = {
    arrRefs: PropTypes.array,
    handlePageSave: PropTypes.func,
    handleCancel: PropTypes.func,
    validationErrors: PropTypes.object,
  }

  const CancelButtons = (props) => (
    <>
      <CancelButton
        id={'createActivity_cancel'}
        onClick={props.handleCancel}
        arrRefs={props.arrRefs}
      />
    </>
  )

  CancelButtons.propTypes = {
    handleCancel: PropTypes.func,
    arrRefs: PropTypes.object,
  }

  const ButtonsForSaveJobsForLater = (props) => (
    <>
      <CancelButton
        id={'createActivity_DialogBox_cancel'}
        arrRefs={props.arrRefs}
        onClick={closeGeneralDialog}
      />
      <SaveButton
        id={'createActivity_DialogBox_saveJob'}
        arrRefs={props.arrRefs}
        postService={props.postService}
        saveLabel="buttons.saveJob"
      />
    </>
  )

  ButtonsForSaveJobsForLater.propTypes = {
    arrRefs: PropTypes.array,
    postService: PropTypes.func,
  }

  const getTemplateFields = async () => {
    const templateDataRaw = await gdeTransactions.getTemplateById(
      getState()?.templateData?.templateName
    )
    const templateData = templateDataRaw.data()
    const fields = templateData.templateFields
    if (getState()?.templateData?.assetType !== 'Box Transmittal') {
      delete fields.skpBoxId
    }
    
    delete fields.customerId

    const finalArrayFields = Object.keys(fields).map((key) => {
      const data = fields[key]
      data.name = key
      return data
    })

    finalArrayFields.sort((a, b) =>
      a.customOrder > b.customOrder ? 1 : b.customOrder > a.customOrder ? -1 : 0
    )

    const checkCountry = countryConfig.find(
      (entry) => entry.countryCode === getState()?.templateData?.countryCode
    )
    finalArrayFields.forEach((field) => {
      if (field?.dataType === 'Date') {
        if (checkCountry) {
          field.customFormat = checkCountry.dateFormat
        } else {
          field.customFormat = defaultDateFormat2
        }
      }
    })
    return Promise.resolve(finalArrayFields)
  }

  const postService = async (postObject) => {
    const arrPost = tableRef.current.dataManager.data
    // eslint-disable-next-line
    function check(row) {
      return row.tableData.checked === false
    }

    const noFieldSelected = arrPost.every(check)
    if (noFieldSelected) {
      return handleAdditionalFieldPopUp()
    }

    let isBlankCustomFieldName = false
    arrPost.forEach((r) => {
      if (r.tableData.checked) {
        if (
          (r.customName === '' || r.customName === undefined) &&
          !isBlankCustomFieldName
        ) {
          isBlankCustomFieldName = true
        }
      }
    })

    if (isBlankCustomFieldName) {
      errorToast({
        message: t('smartCatalog.emptyTemplateField'),
        title: t('toast.error'),
      })
      return false
    }

    const fields = {}
    let checkedFieldsCount = 0
    arrPost.forEach((r) => {
      if (r.tableData.checked) {
        const fieldData = {
          format: r.customFormat || r.format,
          isRequired: r.isRequired,
          length: Number(r.customLength),
          fieldId: r.name,
          sampleValue: r.defaultValue,
          hasSample: Boolean(r.defaultValue),
          doNotDuplicate: r.doNotDuplicate || '',
          verify: r.verify || '',
          isLocked: false,
          lockedValue: '',
          instructions: r.instructionData || '',
        }
        fields[r.customName.split(' ').join('')] = fieldData
        checkedFieldsCount++
      }
    })

    if (Object.keys(fields).length === checkedFieldsCount) {
      const data = {
        updatedTS: new Date().toISOString(),
        template: fields,
        customTemplateName: editedCustomTemplateName,
      }

      await gdeTransactions.updateSmartCatalogTemplate(templateId, data)
      setTimeout(snackBar(t('toast.templateUpdate')), 50000)
      navigateBackToViewTemplate()
    } else {
      errorToast({
        message: t('toast.duplicateTemplateField'),
        title: t('toast.error'),
      })
    }
  }

  const ButtonsForAdditionalFieldDialog = () => (
    <>
      <ContainedButton onClick={closeGeneralDialog}>buttons.Ok</ContainedButton>
    </>
  )

  const handleAdditionalFieldPopUp = () => {
    openGeneralDialog({
      title: t('options.aaditionFieldWarning'),
      message: t('options.aaditionFieldMessage'),
      noTranslate: true,
      noTranslateTitle: true,
      buttons: <ButtonsForAdditionalFieldDialog />,
      closeX: true,
    })
  }

  const filterData = location.state?.filterData

  const navigateBackToViewTemplate = () => {
    if (filterData) {
      history.push(routePaths.viewTemplate, { filterData })
    } else {
      history.push(routePaths.viewTemplate)
    }
  }

  const handleCancel = () => {
    navigateBackToViewTemplate()
  }

  const requestDetails = [
    {
      label: t('Search.wms'),
      value: getState().templateData.wmsCode,
    },
    {
      label: t('templates.accountLevelOne'),
      value: getState().templateData.accountLevel1,
    },
    {
      label: t('templates.accountLevelTwo'),
      value: getState().templateData.accountLevel2,
    },
    {
      label: t('templates.accountLevelThree'),
      value: getState().templateData.accountLevel3,
    },
    {
      label: t('templates.assetType'),
      value: getState().templateData.assetType,
    },
    {
      label: t('templates.templateType'),
      value: getState().templateData.templateType,
    },
    {
      label: t('templates.lineOfBusiness'),
      value: getState().templateData.lob,
    },
    {
      label: t('templates.customTemplateName'),
      value: getState().templateData.customTemplateName,
      // editable: false,
    },
  ]

  const [isEditingCustomTemplateName, setIsEditingCustomTemplateName] = useState(false)
  const [editedCustomTemplateName, setEditedCustomTemplateName] = useState(getState()?.templateData?.customTemplateName || '')

  const handleCustomTemplateNameClick = () => {
    setIsEditingCustomTemplateName(true)
  }

  const handleCustomTemplateNameChange = (event) => {
    // console.log(event.target.value, 'Eventsample')
    setEditedCustomTemplateName(event.target.value)
  }

  const handleSaveCustomTemplateName = () => {
    // Handle saving the edited custom template name here
   
    setIsEditingCustomTemplateName(false)
  }


  return (
    <MainRouteSubRoutePage
      mainTitle="routeTitles.editTemplate"
      buttons={
        getState()?.templateData && (
          <Buttons
            arrRefs={arrRefs}
            handleCancel={handleCancel}
            handlePageSave={postService}
            validationErrors={getState().validationErrors}
          />
        )
      }
      createPage={true}
    >
      <Box className={classes.containerGroup} style={{ margin: '0 0 0 4px' }}>
        <Container className={classes.container} style={{ }}>
          {requestDetails.map(
            (detail) =>
              // detail.value && (
              <Typography variant="body1" className={classes.content}>
                <span className={classes.label}>{detail.label}: </span>
                <span className={classes.value} onClick={handleCustomTemplateNameClick} >

                  {(detail.label === t('templates.customTemplateName'))
                    ? (
                      <div style={{ display: 'flex' }}>

                        {isEditingCustomTemplateName
                          ? (
                            <><TextField
                              style={{ text: 'centre', width: 'fit-content', padding: '3px' }}
                              type="text"
                              className={classes.editableInput}
                              value={editedCustomTemplateName}
                              onChange={handleCustomTemplateNameChange}
                              size="small"
                              contentEditable="true"
                            /><IconButton onClick={handleSaveCustomTemplateName} color="primary" style={{ padding: '4px' }}>
                              <EditIcon />
                            </IconButton></>
                            )
                          : (
                            <><div>
                              {detail.value}

                            </div><IconButton onClick={handleCustomTemplateNameClick} color="primary" style={{ marginLeft: '8px', padding: '4px' }}>
                              <EditIcon />
                            </IconButton></>
                            )}
                      </div>
                      )
                    : (
                        detail.value
                      )}
                </span>
                {/* //  <span className={classes.value}>{detail.value} </span> */}
              </Typography>
            // )
          )}
        </Container>
      </Box>
      <XDivider width="18px" />
      {getState().templateData
        // eslint-disable-next-line multiline-ternary
        ? (
          <Box component="div" style={{ margin: '0.5rem' }}>
            <VerticalDivider />
            <TemplateFormat
              tableRef={tableRef}
              getPageData={getTemplateFields}
              title={getState().templateData.templateName}
            // setSelectedTemplateValues={saveTemplateValues}
              wms={getState()?.templateData.wmsCode}
              modify={true}
              formTemplates={formTemplate}
              skpEncoding={getState()?.skpEncoding}
              arrRefs={arrRefs}
              isEdit={false}
              getState={getState}
              customFields={getState()?.templateData?.template}
          />
          </Box>
          ) : null}
    </MainRouteSubRoutePage>
  )
}

ModifyTemplate.propTypes = {}

export default ModifyTemplate
